import defaultIcons from 'ui/configs/common/icons';

export default {
    icons: defaultIcons,
};
